import { render, staticRenderFns } from "./DumbappPreview.vue?vue&type=template&id=56a4600e&scoped=true&"
import script from "./DumbappPreview.vue?vue&type=script&lang=js&"
export * from "./DumbappPreview.vue?vue&type=script&lang=js&"
import style0 from "./DumbappPreview.vue?vue&type=style&index=0&id=56a4600e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4600e",
  null
  
)

export default component.exports